import React from "react";
import { RAIL_WIDTH_MOBILE } from "../sideMenuDensity";

type SideMenuMobileShellProps = {
  isOpen: boolean;
  onBackdropClick: () => void;
  children: React.ReactNode;
};

const SideMenuMobileShell: React.FC<SideMenuMobileShellProps> = ({
  isOpen,
  onBackdropClick,
  children,
}) => (
  <>
    {isOpen && (
      <div
        className="
          fixed inset-0 bg-black/50 z-80
          transition-opacity duration-300
        "
        onClick={onBackdropClick}
        role="presentation"
      />
    )}
    <div
      className={`
        mobile-menu-drawer
        fixed top-0 left-0 h-screen z-50
        ${RAIL_WIDTH_MOBILE}
        bg-semantic-bg-primary
        text-gray-700
        border-r border-semantic-border-primary
        flex flex-col
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
      `}
    >
      {children}
    </div>
  </>
);

export default SideMenuMobileShell;
